(() => {
  function productPricing(product, formatter, fromTemplate) {
    const variants = (product.variants || []).filter(v => v.price !== null && v.price !== '' && Number.isFinite(Number(v.price)));
    const variant = variants.reduce((lowest, v) => !lowest || Number(v.price) < Number(lowest.price) ? v : lowest, null);
    if (!variant) return {variant:null, label:''};
    const amount = formatter.format(Number(variant.price) / 100);
    const varies = new Set(variants.map(v => Number(v.price))).size > 1;
    return {variant, label:varies ? (fromTemplate || '[price]').replace('[price]', amount) : amount};
  }
  const key = 'sm_wishlist_v1';
  const root = window.Shopify?.routes?.root || '/';
  const valid = h => typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h);
  const clean = value => Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 50) : [];
  const read = () => { try { return clean(JSON.parse(localStorage.getItem(key) || '[]')); } catch { return []; } };
  const path = handle => root + 'products/' + encodeURIComponent(handle);
  const setup = () => {
    const host = document.querySelector('[data-sm-wishlist]');
    if (!host || host.dataset.ready) return;
    host.dataset.ready = 'true';
    const strings = JSON.parse(host.querySelector('[data-wish-strings]').textContent);
    const dialog = host.querySelector('dialog');
    const grid = host.querySelector('[data-wish-grid]');
    const message = host.querySelector('[data-wish-message]');
    const retry = host.querySelector('[data-wish-retry]');
    const status = host.querySelector('[data-wish-status]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:host.dataset.currency || 'USD'});
    let revision = 0;
    const updateButtons = () => {
      const saved = read();
      document.querySelectorAll('[data-wish-toggle]').forEach(button => {
        const selected = saved.includes(button.dataset.wishToggle);
        button.disabled = !valid(button.dataset.wishToggle);
        button.setAttribute('aria-pressed', String(selected));
        const label = button.querySelector('[data-wish-label]');
        if (label) label.textContent = selected ? strings.saved : strings.save;
      });
      document.querySelectorAll('[data-wish-open]').forEach(button => {button.disabled = false;});
      document.querySelectorAll('[data-wish-count]').forEach(count => {count.textContent = String(saved.length); count.hidden = !saved.length;});
    };
    const store = handles => {
      try { localStorage.setItem(key, JSON.stringify(clean(handles))); return true; }
      catch { status.textContent = strings.storage_error; if (dialog.open) message.textContent = strings.storage_error; return false; }
    };
    const card = (handle, result) => {
      const li = document.createElement('li');
      li.className = 'sm-wishlist__card';
      const product = result.product;
      if (product) {
        const link = document.createElement('a');
        link.href = path(handle);
        if (product.featured_image) {
          try {
            const url = new URL(product.featured_image, location.origin);
            if (url.protocol === 'https:' || url.protocol === 'http:') {
              const image = document.createElement('img');
              image.src = url.href; image.alt = product.title; image.width = 360; image.height = 450; image.loading = 'lazy';
              link.append(image);
            }
          } catch {}
        }
        const title = document.createElement('h3'); title.textContent = product.title;
        const price = document.createElement('p');
        price.textContent = productPricing(product, money, strings.from_price).label;
        link.append(title, price);
        if (!product.available) {const sold = document.createElement('p'); sold.className = 'sm-product-badge sm-product-badge--sold'; sold.textContent = strings.sold_out; link.append(sold);}
        const view = document.createElement('span'); view.className = 'sm-wishlist__view'; view.textContent = strings.view; link.append(view);
        li.append(link);
      } else {
        const text = document.createElement('p'); text.textContent = result.missing ? strings.unavailable : strings.retry; li.append(text);
      }
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.wishRemove = handle; remove.textContent = strings.remove;
      if (product?.title) remove.setAttribute('aria-label', strings.remove + ': ' + product.title);
      li.append(remove);
      return li;
    };
    const pendingRequests = new Set();
    const cancelRequests = () => {
      pendingRequests.forEach(controller => controller.abort());
      pendingRequests.clear();
    };
    const fetchProduct = async handle => {
      const controller = new AbortController();
      pendingRequests.add(controller);
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(path(handle) + '.js', {signal:controller.signal});
        if (!response.ok) return {missing:response.status === 404};
        const product = await response.json();
        return product && typeof product.title === 'string' ? {product} : {};
      } finally {
        clearTimeout(timeout);
        pendingRequests.delete(controller);
      }
    };
    const render = async () => {
      const version = ++revision;
      cancelRequests();
      let failed = false;
      if (retry) {retry.hidden = true; retry.disabled = true;}
      const saved = read(); grid.replaceChildren();
      message.textContent = saved.length ? strings.loading : strings.empty;
      grid.setAttribute('aria-busy', 'true');
      for (let start = 0; start < saved.length; start += 6) {
        const handles = saved.slice(start, start + 6);
        const results = await Promise.allSettled(handles.map(fetchProduct));
        if (version !== revision) return;
        results.forEach((result, index) => {
          const value = result.status === 'fulfilled' ? result.value : {};
          if (!value.product && !value.missing) failed = true;
          grid.append(card(handles[index], value));
        });
      }
      if (version === revision) {
        message.textContent = saved.length ? (failed ? (strings.retry_summary || strings.retry) : '') : strings.empty;
        grid.removeAttribute('aria-busy');
        if (retry) {retry.hidden = !failed; retry.disabled = false;}
      }
    };
    document.addEventListener('click', event => {
      const open = event.target.closest('[data-wish-open]');
      const toggle = event.target.closest('[data-wish-toggle]');
      const remove = event.target.closest('[data-wish-remove]');
      if (open) {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
        render();
      } else if (toggle || remove) {
        event.preventDefault();
        const handle = (toggle || remove).dataset[toggle ? 'wishToggle' : 'wishRemove'];
        if (!valid(handle)) return;
        let saved = read(); const exists = saved.includes(handle);
        if (toggle && !exists && saved.length >= 50) {status.textContent = strings.limit; return;}
        saved = exists || remove ? saved.filter(h => h !== handle) : [handle, ...saved];
        if (!store(saved)) return;
        status.textContent = exists || remove ? strings.removed : strings.saved;
        updateButtons();
        if (dialog.open) render().then(() => {grid.querySelector('[data-wish-remove]')?.focus();});
      } else if (event.target.closest('[data-wish-retry]')) {
        event.preventDefault();
        if (retry && !retry.disabled && dialog.open) render();
      } else if (event.target.closest('[data-wish-close]')) dialog.close();
    });
    dialog.addEventListener('close', () => {revision++; cancelRequests();});
    window.addEventListener('storage', event => {if (event.key === key) {updateButtons(); if (dialog.open) render();}});
    document.addEventListener('shopify:section:load', updateButtons);
    const observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-wish-toggle]') || node.querySelector?.('[data-wish-toggle]'))))) updateButtons();
    });
    observer.observe(document.body, {childList:true, subtree:true});
    updateButtons();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
})();
